<div class="two-factor-login-modal" [ngClass]="{ 'modal--loading': view === twoFactorModalView.loading }">
  @switch (view) {
    @case (twoFactorModalView.sendVerificationCode) {
      <header class="modal__header">
        <h2 [ngStyle]="color && { color: 'black' }" id="modalLabel">{{ twoFactorOptions?.title }}</h2>
        <button
          type="button"
          class="button modal__button--close"
          (click)="closeModal()"
          [attr.aria-label]="'general.label.close' | translate"
        >
          <i class="icon icon-ui-close--sm" [ngStyle]="color && { 'background-color': '#' + color.color }"></i>
        </button>
      </header>
      <div class="modal__content">
        <div class="modal__text" [internalInnerHtml]="twoFactorOptions?.body" [userEventSource]="userEventSource"></div>
        <div class="button__group--column">
          <button
            type="button"
            class="button button--border"
            [style.box-shadow]="color && 'inset 0px 0px 0px 2px #' + color.color"
            (click)="verify(verificationCodeMessageType.email, $event)"
          >
            <span [ngStyle]="color && { color: '#' + color.color }">{{ 'two_factor.label.verify_by_email' | translate }}</span>
          </button>
          <button
            type="button"
            class="button button--border"
            [style.box-shadow]="color && 'inset 0px 0px 0px 2px #' + color.color"
            (click)="verify(verificationCodeMessageType.sms, $event)"
          >
            <span [ngStyle]="color && { color: '#' + color.color }">{{ 'two_factor.label.verify_by_sms' | translate }}</span>
          </button>
        </div>
      </div>
    }
    @case (twoFactorModalView.twoFactorNotPossible) {
      <header class="modal__header">
        <h2 id="modalLabel">{{ twoFactorIncompleteAccount?.title }}</h2>
        <button
          type="button"
          class="button modal__button--close"
          (click)="closeModal()"
          [attr.aria-label]="'general.label.close' | translate"
        >
          <i class="icon icon-ui-close--sm"></i>
        </button>
      </header>
      <div class="modal__content">
        <div class="modal__text" [internalInnerHtml]="twoFactorIncompleteAccount?.body" [userEventSource]="userEventSource"></div>
      </div>
      <div class="modal__footer">
        <button type="button" class="button button--primary" (click)="closeModal()">
          <span>{{ 'general.label.close' | translate }}</span>
        </button>
      </div>
    }
    @default {
      <header class="modal__header">
        <h2 id="modalLabel">{{ 'general.label.loading' | translate }}</h2>
        <button
          type="button"
          class="button modal__button--close"
          (click)="closeModal()"
          [attr.aria-label]="'general.label.close' | translate"
        >
          <i class="icon icon-ui-close--sm"></i>
        </button>
      </header>
      <div class="modal__content">
        <div class="modal__text">
          <p>{{ 'general.label.loading' | translate }}</p>
          <p>{{ 'general.label.loading' | translate }}</p>
          <p>{{ 'general.label.loading' | translate }}</p>
        </div>
      </div>
    }
  }
</div>
